import { MissionPlanUiState } from "@/models/ui/MissionPlanUiState"
import { IMissionPlanProfilNav } from "../missionPlan/IMissionPlanProfilNav"
import { IMissionPlanProfilSci } from "../missionPlan/IMissionPlanProfilSci"
import { IGliderConfig } from "./IGliderConfig"


export interface IGliderCoverageConfig extends IGliderConfig {	 
	prf_nav:Array<IMissionPlanProfilNav>
	prf_sci:Array<IMissionPlanProfilSci>
}

export function getDefaultGliderCoverageConfig({libelle=null,glider_type="SEAEXPLORER",battery_type="pack 18650",bms_type="neogy",payload=[],start_energy=29,end_battery_percent=15,prf_nav=[MissionPlanUiState.getDefaultProfil()],prf_sci=[]}={}) {
	return {		
		libelle,
		glider_type,		
		battery_type,
		bms_type,
		payload,
		start_energy,
		end_battery_percent,
		prf_nav,
		prf_sci
	} as IGliderCoverageConfig
}